import { useTranslation } from "react-i18next"
import { motion } from "motion/react"
import { Icon } from "@iconify-icon/react"

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Button } from "@/components/ui/button"

export const StudentMaterials = () => {
  const { t } = useTranslation(["workspaces", "common"])

  return (
    <Card className="bg-foreground border-none">
      <CardHeader>
        <CardTitle>{t("workspaces:materials", "Materials")}</CardTitle>
        <CardDescription>
          {t("workspaces:materialsDescription", "Learning materials for your subjects")}
        </CardDescription>
      </CardHeader>
      <CardContent className="p-6">
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3, 4, 5].map((_, index) => (
            <motion.div
              key={index}
              animate={{ opacity: 1, scale: 1 }}
              className="bg-side-accent hover:bg-muted flex flex-col rounded-md p-4 transition-colors"
              initial={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >
              <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-md bg-green-500/10">
                <Icon
                  className="h-6 w-6 text-green-500"
                  icon={index % 2 === 0 ? "mdi:file-document-outline" : "mdi:file-pdf-box"}
                />
              </div>
              <h3 className="mb-1 font-medium">
                {t("workspaces:materialTitle", "Material")} #{index + 1}
              </h3>
              <p className="text-muted-foreground mb-3 text-sm">
                {t("workspaces:materialDescription", "Learning resource for your studies")}
              </p>
              <div className="mt-auto">
                <Button className="w-full" size="sm" variant="outline">
                  <Icon className="mr-2 h-4 w-4" icon="mdi:download" />
                  {t("workspaces:download", "Download")}
                </Button>
              </div>
            </motion.div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
